module.exports = __webpack_public_path__ + "img/40.24ad5c01.png";